import {CONVIVA_CUSTOMER_KEY} from '../../../../donotinclude';

import IConfigAnalytics from './Interfaces/IConfigAnalytics';

class ConfigAnalytics implements IConfigAnalytics {
    public viewerId           = '';
    public enable             = false;
    public convivaCustomerKey = CONVIVA_CUSTOMER_KEY;
    public convivaGatewayUrl  = '';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigAnalytics;